import { render } from "./TestimonialOne.vue?vue&type=template&id=c000f6ce"
import script from "./TestimonialOne.vue?vue&type=script&lang=js"
export * from "./TestimonialOne.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__